"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;

var Util_1 = require("./Util");

var Container_1 = require("./Container");

var Global_1 = require("./Global");

var Group = /*#__PURE__*/function (_Container_1$Containe) {
  _inherits(Group, _Container_1$Containe);

  var _super = _createSuper(Group);

  function Group() {
    _classCallCheck(this, Group);

    return _super.apply(this, arguments);
  }

  _createClass(Group, [{
    key: "_validateAdd",
    value: function _validateAdd(child) {
      var type = child.getType();

      if (type !== 'Group' && type !== 'Shape') {
        Util_1.Util.throw('You may only add groups and shapes to groups.');
      }
    }
  }]);

  return Group;
}(Container_1.Container);

exports.Group = Group;
Group.prototype.nodeType = 'Group';
(0, Global_1._registerNode)(Group);